import React from 'react'
import ZestawienieRow from './ZestawienieRow'

const Zestawienie = props => {
  return props.dane.map((element, index) => {
    if (element['Widoczny'] === false )
      return null
    else return <ZestawienieRow
      key={index}
      index={index}
      onSetSectionDataArray={props.onSetSectionDataArray}
      nazwa={element.Nazwa}
      opis={element.Numer ? element.Numer + ' ' + element.Nazwa : element.Nazwa}
      kwotaA={element.KwotaA}
      kwotaB={element.KwotaB}
      kwotaB1={element.KwotaB1}
      poziom={element.Poziom}
      readOnly={!element.Edytowalny}
      czyKwotyWTysiacach={props.czyKwotyWTysiacach}
      isThirdColumn={props.isThirdColumn}
      czyWylaczoneFormuly={props.czyWylaczoneFormuly}
      ukryjKwoty={!element.ZawieraKwoty && props.czyPolaBezKwot}
      czyPozycjaUzytkownika={element.Sciezka.includes(
        'PozycjaUszczegolawiajaca',
      )}
      uszczegolowienie={element.Uszczegolowienie}
      dodajPozycjeUszczegolawiajaca={props.dodajPozycjeUszczegolawiajaca}
      usunPozycjeUszczegolawiajaca={props.usunPozycjeUszczegolawiajaca}
    />
    })
}

export default Zestawienie
